import useSize from '@react-hook/size';
import { useDashboardContext } from 'contexts/DashboardContext';
import Column from 'dashboard-engine/layouts/Column';
import List from 'dashboard-engine/layouts/List';
import Grid, { type GridProps } from 'dashboard-engine/layouts/grid/Grid';
import { useRef, type FC } from 'react';

const SizedGrid: FC<Omit<GridProps, 'size'>> = (props) => {
    const sizeMonitorRef = useRef<HTMLDivElement>(null);
    const [width] = useSize(sizeMonitorRef);
    const { editing } = useDashboardContext();

    return (
        <div ref={sizeMonitorRef} className='w-full' style={{ ...(editing && { width: 'calc(100% - 4rem)' }) }}>
            {width > 0 && <Grid {...props} size={{ width }} />}
        </div>
    );
};

const layoutComponents = {
    list: List,
    grid: SizedGrid,
    column: Column
};

export type LayoutComponentType = keyof typeof layoutComponents;

type RenderLayoutProps = {
    config: { _type: `${'layout' | 'tile'}/${LayoutComponentType}` };
    isLoading: boolean;
};

const RenderLayout: FC<RenderLayoutProps> = ({ config, isLoading = false }) => {
    const component = config._type.split('/').pop() as LayoutComponentType;
    const LayoutComponent = component == null ? undefined : layoutComponents[component];

    if (LayoutComponent == null) {
        return <></>;
    }

    /**
     * TS (reasonably) expects us to pass the superset of all props required by components in layoutComponents,
     * but we weren't when this was a JS file...
     */
    // @ts-expect-error
    return <LayoutComponent config={config} isLoading={isLoading} />;
};

export default RenderLayout;
